"use client";
import Link from "next/link";
import { useState } from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";

const Breadcrumb = ({ pageName }: { pageName: string }) => {
	const [showChatbot, setShowChatbot] = useState(false);

	const steps = [
		{
			id: "0",
			message: "Hey there!",
			trigger: "1",
		},
		{
			id: "1",
			message: "Please write your username",
			trigger: "2",
		},
		{
			id: "2",
			user: true,
			trigger: "3",
		},
		{
			id: "3",
			message: "Hi {previousValue}, how can I help you?",
			trigger: "4",
		},
		{
			id: "4",
			options: [
				{ value: 1, label: "View Courses" },
				{ value: 2, label: "Read Articles" },
			],
			end: true,
		},
	];

	const theme = {
		background: "#C9FF8F",
		headerBgColor: "#197B22",
		headerFontSize: "20px",
		botBubbleColor: "#0F3789",
		headerFontColor: "white",
		botFontColor: "white",
		userBubbleColor: "#FF5733",
		userFontColor: "white",
	};

	const config = {
		botAvatar: "img.png",
		floating: true,
	};

	return (
		<>

			<section className="relative z-10 overflow-hidden pt-28 lg:pt-[150px]">
				<div className="container">
					<div className="-mx-4 flex flex-wrap items-center">
						{/* <div className="w-full px-4 md:w-8/12 lg:w-7/12">
							<div className="mb-8 max-w-[570px] md:mb-0 lg:mb-12">
								{pageName.length > 0 && (
									<div className="inline-block bg-gray-100 border border-gray-300 p-1 shadow-md rounded-md">
										<h1 className="text-2xl font-bold text-black dark:text-white sm:text-3xl">
											{pageName}
										</h1>
									</div>
								)}
								<p className="text-base font-medium leading-relaxed text-body-color"></p>
							</div>
						</div> */}
						<div className="w-full px-4 md:w-4/12 lg:w-5/12 ml-auto">
							<div className="text-end">
								<ul className="flex items-center md:justify-end">
									<li className="flex items-center">
										<Link
											href="/"
											className="pr-1 text-base font-medium text-body-color hover:text-primary">
											Home
										</Link>
										<span className="mr-3 block h-2 w-2 rotate-45 border-r-2 border-t-2 border-body-color"></span>
									</li>
									<li className="text-base font-medium text-primary">{pageName}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Breadcrumb;
